export default [
	{
		settings: true,
		text: "ID",
		value: "id",
		func: true,
		valueFilter: "filter_id",
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Driver name",
		value: "driver",
		func: true,
		valueFilter: 'filter_driver',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Phone",
		value: "phone",
		func: true,
		valueFilter: 'filter_phone',
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Phone 2",
		value: "phone2",
		func: true,
		valueFilter: 'filter_phone2',
		model: { value: 'list' },
		sortable: true,
	},

	{
		settings: true,
		text: "Driver type",
		value: "driver_type",
		func: true,
		valueFilter: 'filter_driver_type',
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Safety service",
		value: "safety",
		func: true,
		valueFilter: 'filter_safety',
		model: { value: 'list' },
		sortable: true,
		modText: true,
	},
	{
		settings: true,
		text: "Salary service",
		value: "service",
		func: true,
		valueFilter: 'filter_service',
		model: { value: 'list' },
		sortable: true,
		modText: true,
	},
	{
		settings: true,
		text: "ELD",
		value: "eld_name",
		func: true,
		valueFilter: 'filter_eld_name',
		model: { value: 'note' },
		sortable: true,
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		func: true,
		valueFilter: 'filter_customer',
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Truck",
		value: "truck_number",
		func: true,
		valueFilter: 'filter_truck',
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Trailer",
		value: "trailer_number",
		func: true,
		valueFilter: 'filter_trailer',
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Trailer type",
		value: "trailer_type",
		func: true,
		valueFilter: 'filter_trailer_type',
		model: { value: 'list' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		func: true,
		valueFilter: 'filter_amount',
		model: { value: 'number' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Payment type",
		value: "payment_type",
		func: true,
		valueFilter: 'filter_payment_type',
		model: { value: 'list' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		buttons: [
			{
				perm: { or: [ 10, 9 ] },
				value: 'edit',
				text: 'Edit driver',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: {
					or: [ 11 ]
				},
				value: 'delete',
				text: 'Delete driver',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
